export default {
  buttons: {
    sign_in: 'Log ind',
    sign_up: 'Opret konto',
    logout: 'Log ud',
  },
  logout_confirm: {
    title: 'Log ud?',
    description: 'Er du sikker på, at du vil logge ud?',
    cancel: 'Annuller',
    confirm: 'Log ud',
  },
};
